import styled from "styled-components"
import theme from "../common/theme"
import { P } from "./Typography"

export const DropdownContainer = styled.div`
    align-self: center;
    display: inline-block;
    position: relative;
    cursor: pointer;
`

export const DropdownContent = styled.div`
    position: absolute;
    display: none;
    min-width: 350px;
    right: 0;
    margin-top: 0.5rem;
    background-color: #f9f9f9;
    border: 1px solid ${theme.palette.border};
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 100;
`

export const DropdownItem = styled(P)`
    display: flex;
    padding: 1rem;
    &:hover {
        background: ${theme.palette.border};
    }
`